/**
 * @description
 * Determine if a value is a URLSearchParams object
 *
 * @example
 * ``` ts
 * isUrlSearchParams(new URLSearchParams());
 * // => true
 * isUrlSearchParams('foo=1&bar=2');
 * // => false
 * ```
 *
 * @param  value The value to test
 * @returns True if value is a URLSearchParams object, otherwise false
 *
 * @docsCategory preference/lang
 * @codeFilter is-url-search-params
 */
export function isUrlSearchParams(value): value is URLSearchParams {
  return (
    typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams
  );
}
